module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/shopHQ.png?b5472579cb6ec3a6f52835a9e9edd662";